import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { UserAgentApplication } from "msal"

import { azureConfig, scopes } from '../azure/azureConfig'
import { getUserState, simpleLogin } from '../redux/userSlice'

import { ReactComponent as ReactWavesSvg } from '../assets/waves.svg'
import beritLogo from '../assets/berit-schulen-logo.png'

// Staging and local development sign in with a username and password against the API.
// Kept in this file rather than a separate route so the two paths share one layout.
const SimpleLoginForm = () => {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const status = useSelector(state => state.userData.status)

  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')

  const submitHandler = useCallback((event) => {
    event.preventDefault()
    dispatch(simpleLogin({userName, password}))
  }, [dispatch, userName, password])

  return (
    <form className="authorization-section__form" onSubmit={submitHandler}>
      <label>
        <span>{t(`authorizationPage.userName`)}</span>
        <input
          type="text"
          value={userName}
          autoComplete="username"
          onChange={(e) => setUserName(e.target.value)}
        />
      </label>

      <label>
        <span>{t(`authorizationPage.password`)}</span>
        <input
          type="password"
          value={password}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </label>

      {status === 'failed' &&
        <p className="authorization-section__error">{t(`authorizationPage.signinFailed`)}</p>
      }

      <button className="button" type="submit" disabled={status === 'loading'}>
        {t(`authorizationPage.signin`)}
      </button>
    </form>
  )
}

const AzureLoginButton = () => {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const location = useLocation()

  const loginHandler = useCallback(() => {
    const userAgentApplication = new UserAgentApplication(azureConfig)

    userAgentApplication.loginPopup({scopes})
    .then((response) => {
      if (response.idToken) {
        localStorage.setItem('userRole', response?.idToken?.claims?.roles)
      }
      dispatch(getUserState())
    })
  }, [dispatch])

  useEffect(() => {
    if (location.hash) {
      loginHandler()
    }
  }, [location, loginHandler])

  return (
    <button className="button" onClick={loginHandler}>{t(`authorizationPage.signin`)}</button>
  )
}

export const AuthorizationPage = () => {
  const {t} = useTranslation()

  return (
    <section className="authorization-section">
      <div className="authorization-section__login-container">
        <div className="authorization-section__salutation">
          <img src={beritLogo} alt="Berit Schulen" />
          <h1>{t(`authorizationPage.welcome`)}</h1>
          <span>{t(`authorizationPage.signAcc`)}</span>
        </div>

        {process.env.REACT_APP_SIMPLE_LOGIN === 'true'
          ? <SimpleLoginForm />
          : <AzureLoginButton />
        }
      </div>

      <div className="authorization-section__waves-container">
        <ReactWavesSvg />
      </div>
    </section>
  )
}
